/**
 * Step 6: Diet Type - Vegetarian, Vegan, etc.
 * Only dietary preferences (no macro strategies - those are in StepFitnessGoal)
 */
import React from 'react';
import { Utensils, Salad, Sprout, Fish, Leaf } from 'lucide-react';

const DIET_TYPES = [
  { id: 'alles', label: 'Alles', icon: Utensils, description: 'Keine Einschränkungen' },
  { id: 'vegetarisch', label: 'Vegetarisch', icon: Salad, description: 'Kein Fleisch' },
  { id: 'vegan', label: 'Vegan', icon: Sprout, description: 'Keine tierischen Produkte' },
  { id: 'pescetarisch', label: 'Pescetarisch', icon: Fish, description: 'Kein Fleisch, nur Fisch' },
  { id: 'flexitarisch', label: 'Flexitarisch', icon: Leaf, description: 'Überwiegend pflanzlich, selten Fleisch' },
];

const StepDietType = ({ prefs, setPrefs }) => {
  return (
    <div className="space-y-4" data-testid="onboarding-step-diet-type">
      <div className="text-center mb-6">
        <Utensils className="w-12 h-12 text-green-500 mx-auto mb-3" />
        <h3 className="text-xl font-bold text-white">Wie isst du?</h3>
        <p className="text-zinc-400 text-sm">Wähle deine Ernährungsweise</p>
      </div>
      
      <div className="grid grid-cols-2 gap-2">
        {DIET_TYPES.map(diet => (
          <button
            key={diet.id}
            onClick={() => setPrefs(prev => ({ ...prev, diet_program: diet.id }))}
            className={`p-3 rounded-lg border-2 text-left transition-all ${
              prefs.diet_program === diet.id
                ? 'border-green-500 bg-green-500/10'
                : 'border-zinc-700 hover:border-zinc-600 bg-zinc-800/50'
            }`}
          >
            <div className="flex items-center gap-2">
              <diet.icon className="w-6 h-6 text-green-400 shrink-0" />
              <div>
                <p className="font-medium text-white text-sm">{diet.label}</p>
                <p className="text-xs text-zinc-500">{diet.description}</p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export { DIET_TYPES };
export default StepDietType;
